var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-data"},[(_vm.showPage && _vm.commonDataReady)?_vm._t("default"):_c('skeleton',{staticClass:"page-data-skeleton",style:(_vm.skeletonStyle),attrs:{"count":6,"column":4,"animate":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }